import React, { PropTypes, Component } from 'react'
import { fromJS } from 'immutable'
import { Colors, Metrics, Fonts } from '../../Themes'
import styled from 'styled-components'
import List from '../List'
import ListItem from '../ListItem'
import Input from '../Input'
import Tag from '../Tag'
import CloseIcon from '../../svg-icons/CloseIcon'

const Container = styled.div`
  position: relative;
  .input-container {
    width: ${props => (props.width ? props.width : 'auto')};
    height: auto;
    border: ${Metrics.borders.default};
    border-radius: ${Metrics.borders.defaultRadius};
    color: black;
    cursor: pointer;
    background: ${Colors.white};
    position: relative;
    outline: none;
    position: relative;

    border-bottom: ${props => (props.open ? 0 : Metrics.borders.default)};
    border-bottom-left-radius: ${props =>
      props.open ? 0 : Metrics.borders.defaultRadius};
    border-bottom-right-radius: ${props =>
      props.open ? 0 : Metrics.borders.defaultRadius};

    .formContainer {
      border: none;
    }

    .list {
      margin: ${Metrics.margins.small};
    }
  }

  .dropdown-list {
    display: ${props => (props.open ? 'block' : 'none')};
    position: absolute;
    background: white;
    width: 100%;
    border: ${Metrics.borders.default};
    border-top: none;
    border-radius: ${Metrics.borders.defaultRadius};
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    top: 30px;
    z-index: 1;
  }

  .tags {
    margin-top: ${Metrics.margins.tiny};
    height: auto;
    margin-bottom: ${Metrics.margins.small};
    text-align: left;
  }

  &.search {
    .input-container {
      border: none;
    }

    .dropdown-list {
      border: none;
      position: inherit !important;
      padding: 0px;
      top: 0px;
    }
  }
`

const NoElements = styled.div`margin-left: ${Metrics.margins.small};`

const Error = styled.div`
  ${Fonts.style.Input};
  color: ${Colors.red};
  margin-top: ${Metrics.margins.tiny};
`

class SearchableDropdown extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
    this.handleClick = this.handleClick.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { open } = this.state
    const { options, value, selectedOptions, error } = this.props

    if (
      (options && !fromJS(options).equals(fromJS(nextProps.options))) ||
      (selectedOptions &&
        !fromJS(selectedOptions).equals(fromJS(nextProps.selectedOptions))) ||
      error !== nextProps.error ||
      value !== nextProps.value ||
      open !== nextState.open
    ) {
      return true
    }
    return false
  }

  handleSearch (event) {
    this.setState({ open: true })
    this.props.handleSearch(event)
  }

  handleClick (el) {
    this.setState({ open: !this.state.open }, () => {
      this.props.handleSelect(el)
    })
  }

  handleFocus () {
    clearTimeout(this.timer)
  }

  handleBlur () {
    setTimeout(() => {
      this.setState({
        open: false
      })
    }, 250)
    if (this.props.handleBlur) {
      this.props.handleBlur()
    }
  }

  render () {
    const {
      placeholder,
      handleSelect,
      options,
      value,
      showTags,
      accessor,
      tagsAccessor,
      required,
      handleInputBlur,
      error,
      inputName,
      className
    } = this.props

    const list =
      options.length > 0 ? (
        options.map((el, index) => {
          return (
            <ListItem
              key={index}
              value={el}
              onClick={() => {
                this.handleClick(el)
              }}>
              {accessor(el)}
            </ListItem>
          )
        })
      ) : (
        <NoElements>No elements found</NoElements>
      )

    const tags =
      showTags &&
      this.props.selectedOptions &&
      this.props.selectedOptions.map((el, index) => {
        return (
          <Tag
            key={`Tag-${index}-index`}
            text={tagsAccessor(el)}
            icon={<CloseIcon onClick={() => handleSelect(el)} />}
          />
        )
      })

    return (
      <Container
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        open={this.state.open}
        tabIndex={'-1'}
        className={`${className} searchable-dropdown`}>
        <div className='dropdown-header input-container'>
          <Input
            name={inputName}
            required={required}
            placeholder={placeholder}
            handleChange={this.handleSearch}
            value={value}
            handleBlur={handleInputBlur}
          />
        </div>
        <div className='dropdown-list'>
          <List className={'list'} hide={!this.state.open}>
            {list}
          </List>
        </div>
        {error && <Error>{error}</Error>}
        <div className='tags'>{tags}</div>
      </Container>
    )
  }
}

SearchableDropdown.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  selectedOptions: PropTypes.array,
  showTags: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  accessor: PropTypes.func.isRequired,
  tagsAccessor: PropTypes.func,
  handleBlur: PropTypes.func,
  error: PropTypes.string,
  handleInputBlur: PropTypes.func,
  required: PropTypes.bool,
  inputName: PropTypes.string,
  className: PropTypes.string
}

export default SearchableDropdown



// WEBPACK FOOTER //
// ./src/components/SearchableDropdown/index.js